import { EmptyState } from "@/components/shared";
import { CalendarCheck } from "lucide-react";
import { ShowingCard } from "@/pages/showings/ShowingCard";

export const ShowingsTab = ({ showings, respondShowing }) => {
  if (showings.length === 0) {
    return <div className="bg-white border border-line rounded-xl"><EmptyState icon={CalendarCheck} title="No showing requests" /></div>;
  }
  return (
    <div className="space-y-3">
      {showings.map((s) => (
        <ShowingCard key={s.id} showing={s} role="landlord" respond={respondShowing} />
      ))}
    </div>
  );
};
